import { Action } from "../../../libs/redux/action";
import {
    LEGAL_REPRESENTATIVE_POPUP_CLOSE_POPUP,
    LEGAL_REPRESENTATIVE_POPUP_OPEN_POPUP,
    LEGAL_REPRESENTATIVE_POPUP_SUBMIT_FORM,
    LEGAL_REPRESENTATIVE_POPUP_SUBMIT_FORM_DONE,
    LEGAL_REPRESENTATIVE_POPUP_VERIFY_IF_CUSTOMER_HAS_LEGAL_REPRESENTATIVE,
    SAVE_LEGAL_REPRESENTATIVE,
} from "../constants";
import { LegalRepresentativePopupState } from "../state";

export class LegalRepresentativePopupOpenPopup extends Action<
    void,
    LegalRepresentativePopupState
> {
    readonly type = LEGAL_REPRESENTATIVE_POPUP_OPEN_POPUP;
    reducer(
        state: LegalRepresentativePopupState
    ): LegalRepresentativePopupState {
        return {
            ...state,
            opened: true,
        };
    }
}

export class LegalRepresentativePopupClosePopup extends Action<
    void,
    LegalRepresentativePopupState
> {
    readonly type = LEGAL_REPRESENTATIVE_POPUP_CLOSE_POPUP;
    reducer(
        state: LegalRepresentativePopupState
    ): LegalRepresentativePopupState {
        return {
            ...state,
            opened: false,
        };
    }
}

export class LegalRepresentativePopupSubmitForm extends Action<
    LegalRepresentativePopupFormModel,
    LegalRepresentativePopupState
> {
    readonly type = LEGAL_REPRESENTATIVE_POPUP_SUBMIT_FORM;
    reducer(
        state: LegalRepresentativePopupState
    ): LegalRepresentativePopupState {
        return {
            ...state,
            form: {
                ...state.form,
                submitting: true,
            },
        };
    }
}

export class LegalRepresentativePopupSubmitFormDone extends Action<
    void | Error,
    LegalRepresentativePopupState
> {
    readonly type = LEGAL_REPRESENTATIVE_POPUP_SUBMIT_FORM_DONE;
    reducer(
        state: LegalRepresentativePopupState
    ): LegalRepresentativePopupState {
        return {
            ...state,
            form: {
                ...state.form,
                submitting: false,
            },
        };
    }
}

export class LegalRepresentativePopupVerifyIfCustomerHasLegalRepresentative extends Action<
    void,
    LegalRepresentativePopupState
> {
    readonly type =
        LEGAL_REPRESENTATIVE_POPUP_VERIFY_IF_CUSTOMER_HAS_LEGAL_REPRESENTATIVE;
    reducer(
        state: LegalRepresentativePopupState
    ): LegalRepresentativePopupState {
        return state;
    }
}

export class SaveLegalRepresentative extends Action<
    {
        name?: string;
        firstSurname: string;
        lastSurname?: string;
        documentNumber: string;
        position: string;
    },
    LegalRepresentativePopupState
> {
    readonly type = SAVE_LEGAL_REPRESENTATIVE;
    reducer(
        state: LegalRepresentativePopupState
    ): LegalRepresentativePopupState {
        return {
            ...state,
            legalRepresentative: {
                ...state.legalRepresentative,
                ...this.payload,
            },
        };
    }
}
